interface EmpreendimentoData {
  idEmpreendimentoCRM: string;
  nome: string;
  cep: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  idRevendaRegiao: string;
  idsImobiliaria: string[];
  torres: { id: number | string; descricao: string; podeExcluir?: boolean }[];
}

export const defaultEmpreendimentoData: EmpreendimentoData = {
  idEmpreendimentoCRM: "",
  nome: "",
  cep: "",
  logradouro: "",
  numero: "",
  bairro: "",
  cidade: "",
  uf: "",
  idRevendaRegiao: "",
  idsImobiliaria: [],
  torres: [{ id: Date.now(), descricao: "", podeExcluir: true }],
};
